module.exports = __webpack_public_path__ + "static/media/web.62937fc8.svg";